<my-bill-back-button
  *ngIf="shouldDisplayBackButton"
  [backButtonType]="'leftArrowPlainText'"
  [shouldGoBackToOverview]="
    shouldGoBackToOverview ||
    (shouldShowAccountSelection &&
      billingAccounts &&
      billingAccounts.length > 1)
  "
></my-bill-back-button>
<h1 [ngClass]="{ 'rs-has-subtit': subtitle }" [attr.data-cy]="testId">
  {{ mainTitle }}
</h1>
<h2 class="rs-subtit" *ngIf="subtitle">{{ subtitle }}</h2>
<my-bill-account-selection
  *ngIf="
    shouldShowAccountSelection && billingAccounts && billingAccounts.length > 1
  "
  [billingAccounts]="billingAccounts"
>
</my-bill-account-selection>
